/* DSL Section-defer — render below-fold sections wanneer ze in viewport komen */
(function(){
  if (!("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target, tpl = el.querySelector("template[data-defer-render]");
      if (tpl) { el.appendChild(tpl.content.cloneNode(true)); tpl.remove(); el.dataset.deferRendered = "1"; }
      io.unobserve(el);
    });
  }, {rootMargin: "200px"});
  document.querySelectorAll("[data-defer-section]").forEach(function(el){ io.observe(el); });
})();